import { Row } from "antd";
import bolger from "assets/images/bolger.svg";
import colors from "constants/colors";
import styled from "styled-components";
import { NAVBAR_HEIGHT } from "components/Nav/Navbar";

export const Carousel = styled(Row)<{ showRightSideControls: boolean; showLeftSideControls: boolean }>`
  overflow-x: auto;
  width: 100%;
  margin: 0 !important;
  padding-top: 20px;
  scroll-right: 75px;
  ::after {
    position: absolute;
    content: " ";
    min-width: 75px;
    z-index: 30;
    background: linear-gradient(to right, rgb(9 40 63 / 0%) 0%, ${colors.primary} 50%, ${colors.primary} 100%);
    transition: opacity 0.2s;
    opacity: ${props => (props.showRightSideControls ? 1 : 0)};
  }
  ::before {
    position: absolute;
    content: " ";
    min-width: 75px;
    z-index: 30;
    background: linear-gradient(to left, rgb(9 40 63 / 0%) 0%, ${colors.primary} 50%, ${colors.primary} 100%);
    transition: opacity 0.2s;
    opacity: ${props => (props.showLeftSideControls ? 1 : 0)};
  }

  ::-webkit-scrollbar {
    width: 0; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
`;

export const CarouselWrapper = styled.div<{ showRightSideControls: boolean; showLeftSideControls: boolean }>`
  position: relative;
  ::after {
    content: " ";
    background: linear-gradient(to left, rgb(9 40 63) 0%, rgb(9 40 63 / 0) 100%);
    min-width: 75px;
    position: absolute;
    height: 100%;
    z-index: 10;
    right: -1px;
    top: 0;
    transition: opacity 0.2s;
    opacity: ${props => (props.showRightSideControls ? 1 : 0)};
  }
  ::before {
    content: " ";
    background: linear-gradient(to right, rgb(9 40 63) 0%, rgb(9 40 63 / 0) 100%);
    min-width: 75px;
    position: absolute;
    height: 100%;
    z-index: 10;
    left: -1px;
    top: 0;
    transition: opacity 0.2s;
    opacity: ${props => (props.showLeftSideControls ? 1 : 0)};
  }
`;

export const CarouselNextButton = styled.button`
  border-radius: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;
  background: var(--neutral-alter);
  font-size: 20px;
  border: none;
  width: 40px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  transition: opacity 0.2s;
  opacity: 1;
`;

export const CarouselLastButton = styled.button`
  border-radius: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;
  background: var(--neutral-alter);
  font-size: 20px;
  border: none;
  width: 40px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  transition: opacity 0.2s;
  opacity: 1;
`;

export const MainContent = styled.div<{ bgOffset?: number }>`
  height: 100vh;
  background-color: ${colors.primary};
  padding-top: ${NAVBAR_HEIGHT}px;
  background-image: url(${bolger});
  background-repeat-y: no-repeat;
  background-position-y: 20vh;
  background-position-x: ${props => (props.bgOffset ? `-${props.bgOffset}px` : "none")};
  transition: background-position-x 0.8s ease-in-out;
  background-size: 350vh;
  overflow: hidden;
`;

export const StyledFirstWave = styled.svg`
  position: absolute;
  left: 0;
  width: max(1000px, 100vw);
  top: 0;
  height: 110px;
  background-size: 100% 100%;
`;

export const StyledSecondWave = styled.svg`
  left: 0;
  top: 0;
  width: max(1000px, 100vw);
  height: 150px;
  background-size: 100% 100%;
`;

export const WaveContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;
